<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <NotificationContainer v-if="!!message" class="messages-container" :message = "message" />
        <ErrorsContainer class="messages-container" :errors = "errors"/>
        <p><b>Update answers of a specific assignment term.</b></p>
        <div>
          <b-form @submit.prevent="submitForm" v-promise-btn="{action: 'submit'}">
            <b-row class="my-1">
              <b-col sm="2">
                <label for="assignmentTermIds">AssignmentTerm IDs: </label>
              </b-col>
              <b-col sm="2">
                <b-input id="assignmentTermIds" required
                         type="text"
                         v-model="formData.assignmentTermIds"
                         placeholder='AssignmentTerm IDs should be comma separated.'/>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label for="productId">Product ID: </label>
              </b-col>
              <b-col sm="2">
                <b-input id="productId" required type="text" v-model="formData.productId"/>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="2">
                <label for="addAnswerUuids">Add Answer UUIDs: </label>
              </b-col>
              <b-col sm="8">
                <b-form-textarea id="addAnswerUuids"
                                 type="text"
                                 rows="2"
                                 v-model="formData.addAnswerUuids"
                                 placeholder="Answer UUIDs should be comma separated."/>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="2">
                <label for="removeAnswerUuids">Remove Answer UUIDs: </label>
              </b-col>
              <b-col sm="8">
                <b-form-textarea id="removeAnswerUuids"
                                 type="text"
                                 rows="2"
                                 v-model="formData.removeAnswerUuids"
                                 placeholder="Answer UUIDs should be comma separated."/>
              </b-col>
            </b-row>
            <b-col md="auto">
              <b-button type="submit" variant="success"> Run </b-button>
            </b-col>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import OptionIdsMaintenanceProvider from '@/services/OptionIdsMaintenanceProvider'
import NotificationContainer from '@/components/NotificationContainer'
import ErrorsContainer from '@/components/ErrorsContainer'

export default {
  name: 'MapExclusionCriteria',
  data () {
    return {
      formData: {
        productId: null,
        addAnswerUuids: '',
        removeAnswerUuids: '',
        assignmentTermIds: null
      },
      message: '',
      errors: []
    }
  },
  components: {
    NotificationContainer,
    ErrorsContainer
  },
  methods: {
    submitForm () {
      this.errors = []
      return new Promise((resolve, reject) => {
        OptionIdsMaintenanceProvider.updateAnswersOfAssignmentTerms(this.formData)
          .then((resp) => {
            this.message = resp.body['message']
            resolve(resp)
          }, (resp) => {
            this.errors = resp.body.errors
            resolve(resp)
          })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#assignmentTermIds, #productId {
  width: 400px;
}
.messages-container {
  margin-bottom: 15px;
}
</style>
